import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import storage from "utils/storage";
import useAuth from "utils/api/auth";
import user_api from "utils/api/users";

export default function LoginDemo() {
  const navigate = useNavigate();

  useEffect(() => {
    async function loginDemoUser() {
      try {
        console.log("Logging in demo user");
        const uiVersion = localStorage.getItem("uiVersion") || "old";
        const result = await useAuth.sign_in_email(
          "sparkletimekeepingdemo+01@gmail.com",
          "Demo1234",
          uiVersion
        );

        if (!result.ok) {
          console.error("Demo login failed", result);
          navigate("/login", { replace: true });
          return;
        }

        const deleteResult = await user_api.delete_demo_last_record("68c272e642a018006930c297")
        if (!deleteResult.ok) {
          return
        }

        const { data } = result;

        // Store user + token
        await storage.storeUser(data);
        await storage.storeToken(data.token);

        navigate("/dashboard/app", { replace: true });
      } catch (err) {
        console.error("Error logging in demo user", err);
        navigate("/login", { replace: true });
      }
    }

    localStorage.setItem("mode", "demo");

    loginDemoUser();
  }, [navigate]);

  return null;
}